S.headerSearchlayer =
    {
        elements: {
            $clear: null,
            $close: null,
        },

        init() {
            this.initSearchLayer();
            this.closeSearchLayer();
        },
        closeSearchLayer() {
            this.elements.$close.on('click', () => {
                // e.stopPropagation().preventDefault();

                S.header.searchLayerClose();
            });
        },
        initSearchLayer() {
            this.elements.$clear.on('click', (e) => {
                $(e.currentTarget).prev('input').val('');
            });
        },


    };
